export const PROJECT_NAV_GROUPS = [
  { labelKey: "Resumen", to: "/overview" },
  {
    labelKey: "Presupuesto",
    children: [
      { labelKey: "Presupuesto", to: "/budgeting" },
      { labelKey: "Cambios", to: "/extras" },
      { labelKey: "dynamicElements", to: "/dynamicElements" },
    ],
  },
  {
    labelKey: "Ejecución",
    children: [
      { labelKey: "Certificaciones", to: "/certificaciones" },
      { labelKey: "Histórico de certificaciones", to: "/certhistory" },
      { labelKey: "Planificación", to: "/planning", disabled: true },
    ],
  },
  {
    labelKey: "Ventas",
    children: [
      { labelKey: "Cuenta cliente", to: "/customer-account", disabled: true },
      { labelKey: "Facturas", to: "/invoices" },
      { labelKey: "Proformas", to: "/proformas", disabled: true },
      { labelKey: "Financiación", to: "/financing", disabled: true },
    ],
  },
  {
    labelKey: "Compras",
    children: [
      { labelKey: "Control de gastos", to: "/expenses" },
      { labelKey: "Pedidos de compra", to: "/purchase-orders" },
    ],
  },
]

export const LIBRARIES_NAV_GROUPS = [
  { labelKey: "Mi banco de precios", to: "/bancodeprecios" },
  {
    labelKey: "Bancos de referencia",
    children: [
      {
        labelKey: "Banco de precios Cype",
        to: "/bancodeprecios/referencia/cype",
      },
      {
        labelKey: "Banco de precios ITeC",
        to: "/bancodeprecios/referencia/bedec",
      },
      {
        labelKey: "Banco de precios Preoc",
        to: "/bancodeprecios/referencia/preoc",
      },
    ],
  },
  { labelKey: "Plantillas", to: "/bancodeprecios/templates" },
  { labelKey: "Eleméntos dinámicos", to: "/bancodeprecios/dynamic-element" },
]

export const SALES_NAV_GROUPS = [
  { labelKey: "Facturas", to: "/invoices" },
  { labelKey: "Proformas", to: "/proformas", disabled: true },
]

export const PURCHASES_NAV_GROUPS = [
  { labelKey: "Control de gastos", to: "/expenses" },
  { labelKey: "Pedidos de compra", to: "/purchase-orders" },
]

export const USER_NAV_GROUPS = [
  { labelKey: "General", to: "/generalProfile" },
  { labelKey: "Perfil", to: "/profile" },
  { labelKey: "Gestión de Equipo", to: "/gestionEquipo" },
  { labelKey: "Suscripción", to: "/subscription" },
  { labelKey: "Personalizar PDF", to: "/general-pdf" },
]
